<template><svg class="icon icon__arrow ico__arrow--left" xmlns="http://www.w3.org/2000/svg" width="8" height="17" viewBox="0 0 8 17" fill="none" role="img" aria-label="Left arrow">
  <path d="M6.98389 1L1.00002 8.21221L6.98389 15.4244" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>